import styles from './PlaceCenter.module.css';
import { LFC } from '../../types';

interface PlaceCenterProps {}

export const PlaceCenter: LFC<PlaceCenterProps> = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
